import { helper } from '@ember/component/helper';
import { COMPONENT_FIELD_MAP } from 'linced-app/utils/reporting';

export default helper(function getSectionField([
  sectionMap,
  studentId,
  templateSectionId,
  componentType,
]) {
  if (!sectionMap || !studentId || !templateSectionId || !componentType) {
    return '';
  }
  let studentSections = sectionMap[studentId];
  if (!studentSections) {
    return '';
  }
  let section = studentSections[templateSectionId];
  if (!section) {
    return '';
  }
  let field = COMPONENT_FIELD_MAP[componentType];
  if (!field) {
    return '';
  }
  return section.get(field) || '';
});
